export default __webpack_public_path__ + "static/media/Icon-3.6d157816.gif";